<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="3">
              <FormInput
                label="campusName"
                placeholder="campusName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" lg="3">
              <FormInput
                label="campusCode"
                placeholder="campusCode"
                :fieldValue.sync="formData.school_code"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="12" lg="6">
              <FormInput
                label="address"
                placeholder="address"
                :fieldValue.sync="formData.address"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card v-if="isAppMode(['DEV', 'UAT'])">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <div class="text-subtitle-1 colorBlack--text font-weight-medium text-capitalize">
                {{ $t('menu.whatsAppSetting') }}
              </div>
            </v-col>
          </v-row>
<!-- 
          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormInput
                syncActive="true"
                label="centerAddress"
                :readonly="sync_address"
              />
            </v-col>
          </v-row> -->

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_hour"
                :fieldValue.sync="formData.center_working_hour"
                label="workingHour"
                :syncValue.sync="formData.center_working_hour_sync"
              />
            </v-col>
          </v-row>
          
          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_transport"
                :fieldValue.sync="formData.center_transport_guide"
                label="transportGuide"
                :syncValue.sync="formData.center_transport_guide_sync"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_tutor_info"
                :fieldValue.sync="formData.center_tutor_info"
                label="tutorInfo"
                :syncValue.sync="formData.center_tutor_info_sync"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_bad_weather"
                :fieldValue.sync="formData.center_bad_weather_info"
                label="badWeatherInfo"
                :syncValue.sync="formData.center_bad_weather_info_sync"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_refund_info"
                :fieldValue.sync="formData.center_refund_info"
                label="refundInfo"
                :syncValue.sync="formData.center_refund_info_sync"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :syncActive="sync_payment_info"
                :fieldValue.sync="formData.center_payment_info"
                label="paymentInfoDetail"
                :syncValue.sync="formData.center_payment_info_sync"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormTextarea from '@/components/formField/FormTextarea.vue'
import FormInput from '@/components/formField/FormInput.vue'

export default {
  name: 'ClassroomDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormTextarea,
    FormInput,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    canEdit() {
      if (this.isAppMode(['T46']) && this.userType === 'admin') return false

      // staff只可以edit所屬分校
      if (this.$validate.DataValid(this.id)) {
        const getUserSchools = this.gfGetUserSchools()
        if (!getUserSchools.includes(this.id)) {
          return false
        }
      }

      return true
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    formData: {
      name: '',
      address: '',
      school_code: '',
      center_working_hour_sync: true,
      center_working_hour: '',
      center_transport_guide_sync: true,
      center_transport_guide: '',
      center_tutor_info_sync: true,
      center_tutor_info: '',
      center_bad_weather_info_sync: true,
      center_bad_weather_info: '',
      center_refund_info_sync: true,
      center_refund_info: '',
      center_payment_info_sync: true,
      center_payment_info: '',
      
    },
    sync_all: true,
    sync_address: true,
    sync_hour: true,
    sync_transport: true,
    sync_tutor_info: true,
    sync_bad_weather: true,
    sync_refund_info: true,
    sync_payment_info: true,
  }),
  methods: {
    async getSchoolById() {
      try {
        const data = await this.$Fetcher.GetSchoolById(this.id)
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
      } catch (err) {
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'SchoolList',
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          name: this.formData.name,
          address: this.formData.address,
          school_code: this.formData.school_code,
          center_working_hour_sync: this.formData.center_working_hour_sync,
          center_working_hour: this.formData.center_working_hour,
          center_transport_guide_sync: this.formData.center_transport_guide_sync,
          center_transport_guide: this.formData.center_transport_guide,
          center_tutor_info_sync: this.formData.center_tutor_info_sync,
          center_tutor_info: this.formData.center_tutor_info,
          center_bad_weather_info_sync: this.formData.center_bad_weather_info_sync,
          center_bad_weather_info: this.formData.center_bad_weather_info,
          center_refund_info_sync: this.formData.center_refund_info_sync,
          center_refund_info: this.formData.center_refund_info,
          center_payment_info_sync: this.formData.center_payment_info_sync,
          center_payment_info: this.formData.center_payment_info,
        }

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateSchool(this.id, payload)
          // update school in menu school list
          const schoolOptions = this.gfGetSettingSchoolOptions()
          if (schoolOptions !== null) {
            for (let i = 0; i < schoolOptions.length; i++) {
              if (schoolOptions[i].value === this.id) {
                schoolOptions[i].text = payload.name
                break
              }
            }
            this.gfUpdateSettingSchoolOptions(schoolOptions, false)
          }

          message = {
            refresh: true,
          }
        } else {
          const data = await this.$Fetcher.NewSchool(payload)
          // add new school from menu school list
          const schoolOptions = this.gfGetSettingSchoolOptions()
          if (schoolOptions !== null) {
            schoolOptions.unshift({ value: data.id, text: data.name })
            this.gfUpdateSettingSchoolOptions(schoolOptions, false)
          }

          // 將new school加返落menu到
          await this._updateUserSchoolsServer(data.id)
          await this._updateNewSchoolMonthPeriod(data.id)
          message = {
            redirect: 'SchoolList',
          }
        }

        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          message: 'message.saveSuccessInMinutes',
          type: 'success',
        })
      } catch (err) {
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },
    _updateUserSchoolsServer(schoolId, remove = false) {
      return new Promise(async (resolve, reject) => {
        try {
          const userData = this.gfGetCurrentUserData()
          if (userData.user_type === 'developer') {
            const { data: schools } = await this.$Fetcher.GetSchools()
            const school_ids = schools.map(el => el.id)
            await this.gfUpdateUserSchools(school_ids)
          } else {
            const data = await this.$Fetcher.GetStaffById(userData.id)
            const school_ids = data.schools
            if (remove) {
              const found = school_ids.findIndex(el => el === schoolId)
              if (found > -1) {
                school_ids.splice(found, 1)
              }
            } else {
              school_ids.push(schoolId)
            }

            await this.gfUpdateUserSchools(school_ids)
            await this.$Fetcher.UpdateStaff(userData.id, {
              schools: school_ids,
            })
          }

          resolve(true)
        } catch {
          resolve(false)
        }
      })
    },
    async _updateNewSchoolMonthPeriod(id) {
      if (this.gEnableRegularPeriod) {
        try {
          await this.$Fetcher.UpdateSchool(id, { month_period: 1 })
        } catch (err) {
          this.$common.error(err)
        }
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteSchool(this.id)
          // remove deleted school from menu school list
          const schoolOptions = this.gfGetSettingSchoolOptions()
          if (schoolOptions !== null) {
            const foundOption = schoolOptions.findIndex(el => el.value === this.id)
            if (foundOption > -1) {
              schoolOptions.splice(foundOption, 1)
            }
            this.gfUpdateSettingSchoolOptions(schoolOptions, false)
          }

          await this._updateUserSchoolsServer(this.id, true)

          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccessInMinutes',
            type: 'success',
            redirect: 'SchoolList',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: ClassroomDetails')
      this.userType = this.gfGetUserType()
      if (this.$validate.DataValid(this.id)) {
        await this.getSchoolById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
